var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGunshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0723 5L16.0723 6.31904",
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.71 5L18.71 6.31904",
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71777 9.97937L17.5892 9.97937",
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.0116C2 7.0451 2.7835 6.2616 3.75 6.2616H20.2166C21.1831 6.2616 21.9666 7.0451 21.9666 8.0116V9.80921C21.9666 10.36 21.7073 10.8787 21.2666 11.2092L19.2952 12.6878C18.9923 12.915 18.6238 13.0378 18.2452 13.0378H16.6H11.9833H9.80393L8.02083 19.6924C7.77069 20.6259 6.8111 21.18 5.87753 20.9298L4.42863 20.5416C3.49507 20.2914 2.94105 19.3318 3.19119 18.3983L4.62754 13.0378H3.75C2.7835 13.0378 2 12.2543 2 11.2878V8.0116ZM6.18045 13.0378L4.64008 18.7865C4.60435 18.9199 4.68349 19.057 4.81686 19.0927L6.26576 19.4809C6.39913 19.5167 6.53621 19.4375 6.57194 19.3041L8.25101 13.0378H8.2383L8.64022 11.5378H11.9833H16.6H18.2452C18.2993 11.5378 18.3519 11.5202 18.3952 11.4878L20.3666 10.0092C20.4296 9.96199 20.4666 9.8879 20.4666 9.80921V8.0116C20.4666 7.87353 20.3547 7.7616 20.2166 7.7616H3.75C3.61193 7.7616 3.5 7.87353 3.5 8.0116V11.2878C3.5 11.4258 3.61193 11.5378 3.75 11.5378H5.05833H6.60265L6.20072 13.0378H6.18045Z",
    fill: "#566376"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89746 16.7887C8.05758 16.837 8.22736 16.8629 8.40317 16.8629H13.3106C14.0398 16.8629 14.6925 16.4108 14.9489 15.7282L15.9575 13.0426C16.0348 12.8368 16.0727 12.6183 16.069 12.3985L16.065 12.1558H14.5648L14.5692 12.4232C14.5698 12.4546 14.5644 12.4858 14.5533 12.5152L13.5447 15.2008C13.508 15.2983 13.4148 15.3629 13.3106 15.3629H8.40317C8.3613 15.3629 8.32182 15.3526 8.28714 15.3344L7.89746 16.7887Z",
    fill: "#566376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGunshot);
export default __webpack_public_path__ + "static/media/gunshot.d44f49a75d434e916eb0e60c81614f0a.svg";
export { ForwardRef as ReactComponent };